import React from "react"
import cn from "classnames"
import { ErrorMessage } from "./Field"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// Native checkbox inside its label, so the whole row is the hit target and
// the visible text is the accessible name. `consent` switches to the
// top-aligned 15px legal-copy layout.
//
// Standalone checkboxes can carry their own error; inside a CheckboxGroup
// the group renders the error instead.
const Checkbox = ({
    name,
    id = name,
    label,
    checked,
    onChange,
    consent,
    required,
    error,
    disabled,
    className,
    ...rest
}) => (
    <div className={className}>
        <label
            className={cn(styles.opt, {
                [styles.optConsent]: consent,
                [styles.optDisabled]: disabled,
            })}
            htmlFor={id}
        >
            <input
                type="checkbox"
                id={id}
                name={name}
                className={styles.check}
                checked={!!checked}
                onChange={onChange}
                disabled={disabled}
                required={required}
                aria-invalid={error ? "true" : undefined}
                aria-describedby={error ? `${id}-error` : undefined}
                {...rest}
            />
            <span className={styles.optText}>{label}</span>
        </label>
        <ErrorMessage id={id}>{error}</ErrorMessage>
    </div>
)

export default Checkbox
